
        var result = require("!!../../../node_modules/css-loader/index.js!./menu-item.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/fw/menu/menu-item.component.css
// module id = 2137
// module chunks = 1